import { render, staticRenderFns } from "./listagemEditais.vue?vue&type=template&id=292c55fb&scoped=true&lang=pug&"
import script from "./listagemEditais.vue?vue&type=script&lang=js&"
export * from "./listagemEditais.vue?vue&type=script&lang=js&"
import style0 from "./listagemEditais.vue?vue&type=style&index=0&id=292c55fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c55fb",
  null
  
)

export default component.exports